import React, {useState, useEffect} from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
/* import LogoMC from "../../../images/MC.png" */
import LogoLAE from "../../../images/LogoLAE.png"
import planEmerg_1 from "../../../images/planEmerg_1.png"
import planEmerg_2 from "../../../images/planEmerg_2.png"
import planEmerg_3 from "../../../images/planEmerg_3.png"
import planEmerg_4 from "../../../images/planEmerg_4.png"
import planEmerg_5 from "../../../images/planEmerg_5.png"
import CircularProgress from '@mui/material/CircularProgress';
import { getFinca, getSale, getVisitSheet } from "../../../services";
import { formatoFechasEs } from "../../../functions/funciones";

const PlanEmergenciaRender = (props) => {
    const { t } = useTranslation('pdfs');

    //proveedores: [{servicio: 1, nombre:"b", telefono:"123456789"}, {servicio: 2, nombre:"c", telefono:"444555666"}],

    const [isLoading, setIsLoading] = useState(false)
    const [proveedores, setProveedores] = useState([])
    const [finca, setFincas] = useState({})
    
    const fetchData = async () => {
        const response = await getFinca(props.params.nif)
        let finca = response
        const respSale = await getSale(props.params.id);
        const visitSheet_id = respSale.detailsCae[0].visitSheet_id;
        const respVisit = await getVisitSheet(visitSheet_id)
        finca.imgURL = `${process.env.REACT_APP_STORAGE_URL}${respVisit.data.img}`
        finca.fechaVisita = formatoFechasEs(finca.visitSheets[0].createdAt)
        setFincas(finca);
        
    }

    useEffect(() =>{
        fetchData();
    },[])

    return ( 
        <>
            {isLoading ? <CircularProgress style={{color:'#92004D', position: 'absolute', top: '50%', left: '50%'}} /> :
                <>
                    <table className="tablePage">
                    <thead><tr><td>
                        <div className="header-space">&nbsp;</div>
                    </td></tr></thead>
                    <tbody>
                        <h1>{t('emergencyPlan.title')}</h1>
                        <h2><b>{t('emergencyPlan.communityOwners')}</b> {finca?.razonSocial}</h2>
                        <h2><b>{t('emergencyPlan.workCenter')}</b> {finca?.direccion}</h2>
                        <h2><b>{t('emergencyPlan.date')}</b> {finca?.fechaVisita}</h2>
                        <div id="imgFinca" style={{ width: '100%', paddingTop: '66.66%', backgroundImage: `url("${finca?.imgURL}")`, backgroundPosition: 'center', backgroundSize: 'cover', marginTop: 100 }}></div>
                        <div className="pagebreak"></div>
                        <h3>{t('emergencyPlan.introduction')}</h3>
                        <p>
                            <span dangerouslySetInnerHTML={{ __html: t('emergencyPlan.intro.text1') }} /><br />
                            {t('emergencyPlan.intro.text2')}<br />
                            {t('emergencyPlan.intro.text3')}<br />
                            {t('emergencyPlan.intro.text4')}
                            <ul>
                                <li>{t('emergencyPlan.intro.text4a')}</li>
                                <li>{t('emergencyPlan.intro.text4b')}</li>
                            </ul>
                            <p>{t('emergencyPlan.intro.text5')}</p>
                            <ul>
                                <li>{t('emergencyPlan.intro.text5a')}</li>
                                <li>{t('emergencyPlan.intro.text5b')}</li>
                                <li>{t('emergencyPlan.intro.text5c')}</li>
                                <li>{t('emergencyPlan.intro.text5d')}</li>
                                <li>{t('emergencyPlan.intro.text5e')}</li>
                            </ul>
                        </p>
                        <div className="pagebreak"></div>
                        <h3>{t('emergencyPlan.plan.title')}</h3>
                        <h4>{t('emergencyPlan.plan.object.title')}</h4>
                        <p>
                            {t('emergencyPlan.plan.object.text')}
                        </p>
                        <ul>
                            <li>{t('emergencyPlan.plan.object.item1')}</li>
                            <li>{t('emergencyPlan.plan.object.item2')}</li>
                            <li>{t('emergencyPlan.plan.object.item3')}</li>
                        </ul>
                        <h4>{t('emergencyPlan.plan.riskFactors.title')}</h4>
                        <p>{t('emergencyPlan.plan.riskFactors.text')}</p>
                        <ul>
                            <li><b>{t('emergencyPlan.plan.riskFactors.conatoTitle')}</b>{t('emergencyPlan.plan.riskFactors.conatoText')}</li>
                            <li><b>{t('emergencyPlan.plan.riskFactors.partialTitle')}</b>{t('emergencyPlan.plan.riskFactors.partialText')}</li>
                            <li><b>{t('emergencyPlan.plan.riskFactors.generalTitle')}</b>{t('emergencyPlan.plan.riskFactors.generalText')}</li>
                        </ul>
                        <h4>{t('emergencyPlan.plan.actions.title')}</h4>
                        <p>{t('emergencyPlan.plan.actions.text')}</p>
                        <ul>
                            <li>{t('emergencyPlan.plan.actions.item1')}</li>
                            <li>{t('emergencyPlan.plan.actions.item2')}</li>
                            <li>{t('emergencyPlan.plan.actions.item3')}</li>
                            <li>{t('emergencyPlan.plan.actions.item4')}</li>
                            <li>{t('emergencyPlan.plan.actions.item5')}</li>
                        </ul>
                        <h4>{t('emergencyPlan.plan.teams.title')}</h4>
                        <p>
                            {t('emergencyPlan.plan.teams.text')}<br />
                            <div className="pagebreak"></div>
                            {t('emergencyPlan.plan.teams.componentsIntro')}
                        </p>
                        <ol type="a">
                            <li>{t('emergencyPlan.plan.teams.componentA')}</li>
                            <li>{t('emergencyPlan.plan.teams.componentB')}</li>
                            <li>{t('emergencyPlan.plan.teams.componentC')}</li>
                            <li>{t('emergencyPlan.plan.teams.componentD')}</li>
                            <li>{t('emergencyPlan.plan.teams.componentE')}</li>
                            <li>{t('emergencyPlan.plan.teams.componentF')}</li>
                            <li>{t('emergencyPlan.plan.teams.componentG')}</li>
                            <li>
                                {t('emergencyPlan.plan.teams.componentH')}
                                <p>{t('emergencyPlan.plan.teams.teamTypesIntro')}</p>
                                <ul>
                                    <li>{t('emergencyPlan.plan.teams.eae')}</li>
                                    <li>{t('emergencyPlan.plan.teams.epa')}</li>
                                    <li>{t('emergencyPlan.plan.teams.epi')}</li>
                                    <li>{t('emergencyPlan.plan.teams.esi')}</li>
                                    <li>{t('emergencyPlan.plan.teams.interventionHead')}</li>
                                    <li>{t('emergencyPlan.plan.teams.emergencyHead')}</li>
                                </ul>
                            </li>
                        </ol>
                        <p>
                            {t('emergencyPlan.plan.teams.ministerialOrder')}<br />
                        </p>
                        <table className="tableRiesgos">
                            <tr>
                                <th>{t('emergencyPlan.plan.teams.highRisk')}</th>
                                <th>{t('emergencyPlan.plan.teams.mediumRisk')}</th>
                                <th>{t('emergencyPlan.plan.teams.lowRisk')}</th>
                            </tr>
                            <tr>
                                <td>{t('emergencyPlan.plan.teams.alarmEvacuationTeams')}</td>
                                <td>{t('emergencyPlan.plan.teams.alarmEvacuationTeams')}</td>
                                <td>{t('emergencyPlan.plan.teams.alarmEvacuationTeams')}</td>
                            </tr>
                            <tr>
                                <td>{t('emergencyPlan.plan.teams.firstAidTeam')}</td>
                                <td>{t('emergencyPlan.plan.teams.firstInterventionTeams')}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{t('emergencyPlan.plan.teams.firstInterventionTeams')}</td>
                                <td>{t('emergencyPlan.plan.teams.secondInterventionTeam')}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{t('emergencyPlan.plan.teams.secondInterventionTeam')}</td>
                                <td>{t('emergencyPlan.plan.teams.interventionHeadShort')}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{t('emergencyPlan.plan.teams.interventionHeadShort')}</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{t('emergencyPlan.plan.teams.emergencyHeadShort')}</td>
                                <td></td>
                                <td></td>
                            </tr>
                        </table>
                        <div className="pagebreak"></div>
                        <h3>{t('emergencyPlan.implementation.title')}</h3>
                        <h4>{t('emergencyPlan.implementation.responsibility.title')}</h4>
                        <p>{t('emergencyPlan.implementation.responsibility.text')}</p>
                        <h4>{t('emergencyPlan.implementation.organization.title')}</h4>
                        <p>{t('emergencyPlan.implementation.organization.text')}</p>
                        <h4>{t('emergencyPlan.implementation.technicalMeans.title')}</h4>
                        <p>
                            {t('emergencyPlan.implementation.technicalMeans.text1')}<br />
                            {t('emergencyPlan.implementation.technicalMeans.text2')}
                        </p>
                        <h4>{t('emergencyPlan.implementation.humanMeans.title')}</h4>
                        <p>{t('emergencyPlan.implementation.humanMeans.text')}</p>
                        <h4>{t('emergencyPlan.implementation.implementationProgram.title')}</h4>
                        <p>{t('emergencyPlan.implementation.implementationProgram.text')}</p>
                        <h4>{t('emergencyPlan.implementation.maintenanceProgram.title')}</h4>
                        <p>
                            {t('emergencyPlan.implementation.maintenanceProgram.text')}
                            <ol type="a">
                                <li>{t('emergencyPlan.implementation.maintenanceProgram.itemA')}</li>
                                <li>{t('emergencyPlan.implementation.maintenanceProgram.itemB')}</li>
                                <li>{t('emergencyPlan.implementation.maintenanceProgram.itemC')}</li>
                            </ol>
                        </p>
                        <h4>{t('emergencyPlan.implementation.investigation.title')}</h4>
                        <p>{t('emergencyPlan.implementation.investigation.text')}</p>
                        <div className="pagebreak"></div>
                        <h4>{t('emergencyPlan.implementation.behavior.title')}</h4>
                        {/* eslint-disable-next-line */}
                        <img src={planEmerg_1} style={{ width: '100%', marginTop: 24 }} />
                        <div className="pagebreak"></div>
                        {/* eslint-disable-next-line */}
                        <img src={planEmerg_2} style={{ width: '100%' }} />
                        <div className="pagebreak"></div>
                        {/* eslint-disable-next-line */}
                        <img src={planEmerg_3} style={{ width: '100%' }} />
                        <div className="pagebreak"></div>
                        {/* eslint-disable-next-line */}
                        <img src={planEmerg_4} style={{ width: '100%' }} />
                        <div className="pagebreak"></div>
                        {/* eslint-disable-next-line */}
                        <img src={planEmerg_5} style={{ width: '100%' }} />
                        <div className="pagebreak"></div>
                        <div className="pageTitle">{t('emergencyPlan.accidentPlan.title')}</div>
                        <ol type="a">
                            <li>{t('emergencyPlan.accidentPlan.itemA')}</li>
                            <li>{t('emergencyPlan.accidentPlan.itemB')}</li>
                        </ol>
                        <p>{t('emergencyPlan.accidentPlan.activatePAS')}</p>
                        <ul>
                            <li>{t('emergencyPlan.accidentPlan.pasItem1')}</li>
                            <li>{t('emergencyPlan.accidentPlan.pasItem2')}</li>
                            <li>{t('emergencyPlan.accidentPlan.pasItem3')}</li>
                            <li>{t('emergencyPlan.accidentPlan.pasItem4')}</li>
                            <li>{t('emergencyPlan.accidentPlan.pasItem5')}</li>
                            <li>{t('emergencyPlan.accidentPlan.pasItem6')}</li>
                        </ul>
                        <h4>{t('emergencyPlan.accidentPlan.firstAid.title')}</h4>
                        <h5>{t('emergencyPlan.accidentPlan.firstAid.eyeSplash.title')}</h5>
                        <p>{t('emergencyPlan.accidentPlan.firstAid.eyeSplash.text')}</p>
                        <h5>{t('emergencyPlan.accidentPlan.firstAid.dizziness.title')}</h5>
                        <p>{t('emergencyPlan.accidentPlan.firstAid.dizziness.text')}</p>
                        <h5>{t('emergencyPlan.accidentPlan.firstAid.electrocution.title')}</h5>
                        <p>{t('emergencyPlan.accidentPlan.firstAid.electrocution.text')}</p>
                        <ul>
                            <li>{t('emergencyPlan.accidentPlan.firstAid.electrocution.item1')}</li>
                            <li>{t('emergencyPlan.accidentPlan.firstAid.electrocution.item2')}</li>
                            <li>{t('emergencyPlan.accidentPlan.firstAid.electrocution.item3')}</li>
                        </ul>
                        <div className="pagebreak"></div>
                        <h5>{t('emergencyPlan.accidentPlan.firstAid.burns.title')}</h5>
                        <p>{t('emergencyPlan.accidentPlan.firstAid.burns.text')}</p>
                        <ul>
                            <li>{t('emergencyPlan.accidentPlan.firstAid.burns.item1')}</li>
                            <li>{t('emergencyPlan.accidentPlan.firstAid.burns.item2')}</li>
                            <li>{t('emergencyPlan.accidentPlan.firstAid.burns.item3')}</li>
                            <li>{t('emergencyPlan.accidentPlan.firstAid.burns.item4')}</li>
                            <li>{t('emergencyPlan.accidentPlan.firstAid.burns.item5')}</li>
                        </ul>
                        <h5>{t('emergencyPlan.accidentPlan.firstAid.poisoning.title')}</h5>
                        <p>{t('emergencyPlan.accidentPlan.firstAid.poisoning.text')}<b>91 562 04 02</b>.</p>
                        <div className="pagebreak"></div>
                        <div className="pageTitle">{t('emergencyPlan.firePlan.title')}</div>
                        <h5>{t('emergencyPlan.firePlan.classification.title')}</h5>
                        <p>
                            {t('emergencyPlan.firePlan.classification.text')}
                        </p>
                        <ul>
                            <li>{t('emergencyPlan.firePlan.classification.conato')}</li>
                            <li>{t('emergencyPlan.firePlan.classification.general')}</li>
                        </ul>
                        <h5><i>{t('emergencyPlan.firePlan.actionsTaken.title')}</i></h5>
                        <p>
                            {t('emergencyPlan.firePlan.actionsTaken.text')}<br />
                            <b>{t('emergencyPlan.firePlan.actionsTaken.alertTitle')}</b>{t('emergencyPlan.firePlan.actionsTaken.alertText')}<br />
                            <b>{t('emergencyPlan.firePlan.actionsTaken.evacuationTitle')}</b>{t('emergencyPlan.firePlan.actionsTaken.evacuationText')}<br />
                            <b>{t('emergencyPlan.firePlan.actionsTaken.interventionTitle')}</b>{t('emergencyPlan.firePlan.actionsTaken.interventionText')}<br />
                            <b>{t('emergencyPlan.firePlan.actionsTaken.externalHelpTitle')}</b>{t('emergencyPlan.firePlan.actionsTaken.externalHelpText')}<br />
                        </p>
                        <h5><u>{t('emergencyPlan.firePlan.evacuate.title')}</u></h5>
                        <ul>
                            <li>{t('emergencyPlan.firePlan.evacuate.item1')}</li>
                            <li>{t('emergencyPlan.firePlan.evacuate.item2')}</li>
                            <li>{t('emergencyPlan.firePlan.evacuate.item3')}</li>
                            <li>{t('emergencyPlan.firePlan.evacuate.item4')}</li>
                            <li>{t('emergencyPlan.firePlan.evacuate.item5')}</li>
                            <li>{t('emergencyPlan.firePlan.evacuate.item6')}</li>
                            <li>{t('emergencyPlan.firePlan.evacuate.item7')}</li>
                        </ul>
                        <div className="pagebreak"></div>
                        <h5>{t('emergencyPlan.firePlan.trapped.title')}</h5>
                        <p>
                            {t('emergencyPlan.firePlan.trapped.text1')}<br />
                            {t('emergencyPlan.firePlan.trapped.text2')}<br />
                        </p>
                        <h5>{t('emergencyPlan.firePlan.personOnFire.title')}</h5>
                        <p>{t('emergencyPlan.firePlan.personOnFire.text')}</p>
                        <ul>
                            <li>{t('emergencyPlan.firePlan.personOnFire.item1')}</li>
                            <li>{t('emergencyPlan.firePlan.personOnFire.item2')}</li>
                            <li>{t('emergencyPlan.firePlan.personOnFire.item3')}</li>
                        </ul>
                        <p>
                            <span dangerouslySetInnerHTML={{ __html: t('emergencyPlan.firePlan.personOnFire.text2') }} /><br />
                            {t('emergencyPlan.firePlan.personOnFire.text3')}<br />
                        </p>
                        <div className="pagebreak"></div>
                        <h3>{t('emergencyPlan.recommendations.title')}</h3>
                        <ul>
                            <li>{t('emergencyPlan.recommendations.item1')}</li>
                            <li>{t('emergencyPlan.recommendations.item2')}</li>
                            <li>{t('emergencyPlan.recommendations.item3')}</li>
                            <li>{t('emergencyPlan.recommendations.item4')}</li>
                            <li>{t('emergencyPlan.recommendations.item5')}</li>
                            <li>{t('emergencyPlan.recommendations.item6')}</li>
                            <li>{t('emergencyPlan.recommendations.item7')}</li>
                            <li>{t('emergencyPlan.recommendations.item8')}</li>
                            <li>{t('emergencyPlan.recommendations.item9')}</li>
                            <li>{t('emergencyPlan.recommendations.item10')}</li>
                            <li>{t('emergencyPlan.recommendations.item11')}</li>
                            <li>{t('emergencyPlan.recommendations.item12')}</li>
                            <li>{t('emergencyPlan.recommendations.item13')}</li>
                            <li>{t('emergencyPlan.recommendations.item14')}</li>
                            <li>{t('emergencyPlan.recommendations.item15')}</li>
                            <li>{t('emergencyPlan.recommendations.item16')}</li>
                            <li>{t('emergencyPlan.recommendations.item17')}</li>
                            <li>{t('emergencyPlan.recommendations.item18')}</li>
                            <li>{t('emergencyPlan.recommendations.item19')}</li>
                        </ul>
                        <div className="pagebreak"></div>
                        <h3>{t('emergencyPlan.utilityPhones.title')}</h3>
                        <table className="simpleTable">
                            <tr>
                                <th></th>
                                <th>{t('emergencyPlan.phone')}</th>
                            </tr>
                            <tr style={{ color: 'red', fontWeight: 'bold' }}>
                                <td style={{ fontSize: 16 }}>{t('emergencyPlan.utilityPhones.emergencyCoordination')}</td>
                                <td style={{ fontSize: 24, textAlign: 'center' }}>112</td>
                            </tr>
                        </table>
                        <h3>{t('emergencyPlan.directory.title')}</h3>
                        <p>
                            <b>{t('emergencyPlan.directory.workCenterLabel')}</b>{finca.direccion}<br />
                        </p>
                        <div className="pageTitle">{t('emergencyPlan.directory.maintenanceCompanies')}</div>
                        <table className="simpleTable">
                            <tr>
                                <th>{t('emergencyPlan.service')}</th>
                                <th>{t('emergencyPlan.name')}</th>
                                <th>{t('emergencyPlan.phone')}</th>
                            </tr>
                            {proveedores.map((proveedor) => {
                                return (
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                )
                            })}
                        </table>
                        <h3>{t('emergencyPlan.associatedTechnician.title')}</h3>
                        <p>
                            {t('emergencyPlan.associatedTechnician.text')}<b>{finca?.tecnico?.nombre}</b>{t('emergencyPlan.associatedTechnician.role')}<br />
                        </p>
                    </tbody>
                    </table>
                    <div className="pdf-header">
                        <img src={LogoLAE} alt="Logo LAE" />
                        {/* <img src={LogoMC} alt="Logo MC" /> */}
                    </div>
                    <style jsx>{`
                    .tablePage{
                        width: 100%;
                    }
                    .pdf-header {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        position: fixed;
                        top: 0;
                        background-color: #ffffff
                    }
                    .header-space, .pdf-header {
                        height: 90px;
                        
                    }
                    .pdf-header img {
                        height: 60px
                    }
                    div {
                        font-size: 10px
                    }
                    h1 {
                        margin-top: 100px;
                        margin-bottom: 60px;
                        font-size: 20px;
                    }
                    h2 {
                        font-size: 18px;
                        font-weight: 400;
                    }
                    h3 {
                        width: 100%;
                        padding: 5px 10px;
                        background-color: #f8f8f8;
                        text-transform: uppercase;
                        border: 1px solid #e6e6e6;
                        margin-top: 25px;
                        margin-bottom: 15px;
                    }
                    h4 {
                        color: #ab2a3e;
                        margin-bottom: 10px;
                        margin-top: 20px;
                        font-size: 13px;
                    }
                    h5 {
                        font-size: 12px;
                        margin-top: 15px;
                        margin-bottom: 5px;
                    }
                    .textBox {
                        border: 2px solid #e6e6e6;
                        padding: 15px;
                        margin-top: 15px;
                    }
                    .tableRiesgos {
                        border-collapse: collapse;
                        width: 100%;
                        table-layout: fixed;
                        margin-bottom: 24px;
                    }
                    .simpleTable th, .simpleTable td, .tableRiesgos th, .tableRiesgos td {
                        border: 1px solid #000000;
                        padding: 5px;
                        line-height: 1.1
                    }
                    .tableRiesgos th {
                        background-color: #375491;
                        color: #ffffff;
                        font-size: 12px;
                        font-weight: bold;
                    }
                    .simpleTable {
                        border-collapse: collapse;
                        width: 80%;
                        margin: 0 10% 24px 10%;
                    }
                    .simpleTable th {
                        text-transform: uppercase
                    }
                    ul, ol {
                        line-height: 1.8
                    }
                    p {
                        line-height: 1.8;
                        text-align: justify;
                    }
                    br {
                        display: block;
                        margin: 18px 0 20px 0;
                        line-height: 22px;
                        content: " ";
                    }
                    .pageTitle {
                        text-align: center;
                        text-decoration: underline;
                        font-weight: bold;
                        font-size: 12px;
                        margin-bottom: 20px;
                    }
                    @page {
                        size: A4 portrait;
                        margin: 2cm
                    }
                    `}</style>
                </>
            }
        </>
    );
}
 

export default withRouter(PlanEmergenciaRender);
